const styles = {
    field: {
        fontSize: '16px',
        lineHeight: '24px',
        width: '100%',
        minHeight: '72px',
        display: 'inline-block',
        position: 'relative',
        backgroundColor: 'transparent',
        fontFamily: 'Roboto, sans-serif',
        transition: 'height 200ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
        cursor: 'auto'
    },
    span: {
        position: 'absolute',
        lineHeight: "22px",
        top: 38,
        transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
        zIndex: 1,
        transform: "scale(0.75) translate(0px, -28px)",
        transformOrigin: "left top 0px",
        pointerEvents: "none",
        userSelect: "none",
        color: "rgba(0, 0, 0, 0.3)",
        fontSize: '16px',
        fontFamily: 'Roboto, sans-serif'
    },
    editor: {
        paddingTop: 36,
        position: 'relative',
        width: '100%',
        borderTop: 'none rgb(224, 224, 224)',
        borderLeft: 'none rgb(224, 224, 224)',
        borderRight: 'none rgb(224, 224, 224)',
        borderBottom: '1px solid rgb(224, 224, 224)',
        outline: 'none',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        cursor: 'inherit',
        fontStyle: 'inherit',
        fontVariant: 'inherit',
        fontWeight: 'inherit',
        fontStretch: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        fontFamily: 'inherit',
        opacity: 1,
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        height: '100%',
        boxSizing: 'border-box',
    },
    textArea: {
        marginTop: 36,
        position: 'relative',
        width: '100%',
        resize: 'none',
        overflow: 'auto'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/form/ControlledEditor/ControlledEditor.css.js